const employmentTypes = [
  { key: 'permanent-employment', label: 'Permanent employment' },
  { key: 'fixed-term-employment', label: 'Fixed-term employment' },
  { key: 'part-time-work', label: 'Contractor/freelance work' },
];

export default employmentTypes;
